import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/virtualredtag/header-tag.svg'


const _withScopeId = n => (_pushScopeId("data-v-fe7107c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "vrt-slim-header-outlined-icon"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "vrt-slim-header-title" }, "Virtual Red Tag", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgRedTag = _resolveComponent("SvgRedTag")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["vrt-slim-header", { 'vrt-slim-header-outlined': _ctx.outlined }])
  }, [
    (_ctx.outlined)
      ? (_openBlock(), _createElementBlock("img", _hoisted_1))
      : (_openBlock(), _createBlock(_component_SvgRedTag, {
          key: 1,
          class: "vrt-slim-header-icon"
        })),
    _hoisted_2
  ], 2))
}